import React from "react";
import PropTypes from "prop-types";
import { Card, CardImg } from "reactstrap";

/**
 * Renders a <Card /> component
 * @param {Object} imageInfo - The object containing image information.
 * @param {string} imageInfo.src - The source of an image with jpeg extension.
 * @param {string} imageInfo.srcsetWebp - The source of an image with webp extension.
 * @param {string} imageInfo.caption - The caption of the image.
 * @returns an image card.
 */
const ListItem = ({ imageInfo }) => {
  const { src, srcsetWebp, caption } = imageInfo;
  return (
    <Card>
      <picture>
        <source type="image/webp" srcSet={srcsetWebp} />
        <source type="image/jpeg" srcSet={src} />
        <CardImg src={src} alt={caption} />
      </picture>
    </Card>
  );
};

ListItem.propTypes = {
  imageInfo: PropTypes.shape({
    src: PropTypes.string,
    srcsetWebp: PropTypes.string,
    caption: PropTypes.string,
  }),
};

ListItem.defaultProps = {
  imageInfo: {
    src: "",
    srcsetWebp: "",
    caption: "",
  },
};

export default ListItem;
